import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {CacheStorageService} from './cache-storage.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';

// import {AngularIndexedDB} from 'angular2-indexeddb';
// import {AngularIndexedDB} from '../../shared/classes/angular2-indexeddb';


@Injectable()
export class ReviewerFilmService {
	constructor(
		private http: Http,

		private authService: AuthService,
		private cacheStorage: CacheStorageService,
		private config: ConfigService,
		private log: LogService
	) {

		// console.log('-----> creating AngularIndexedDB');
		// this.db = new AngularIndexedDB('oceanbluffproductions', 1);
		// console.log('this.db');
		// console.log(this.db);

		// setTimeout(() => {
		// 	console.log('-----> creating store');
		// 	this.db.createStore(1, (evt) => {
		// 		console.log('-----> creating store returning');
		// 		let objectStore = evt.currentTarget.result.createObjectStore('films', { keyPath: 'filmId', autoIncrement: false });
		// 		objectStore.createIndex('filmId', 'filmId', { unique: false });
		// 	});

		// }, 100);
	}

	// db: any = {};

	allFilms: any = {};
	allFilmsWithArray: any = {};


	getFilms() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/films', options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// films.allFilms.films

					// console.log(foo);
					let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {


						if (a.title.toLowerCase() === b.title.toLowerCase()) {
							return 0;
						}
						if (a.title.toLowerCase() < b.title.toLowerCase()) {
							return -1;
						}
						return 1;

						// if (a.sortSubmissionId === b.sortSubmissionId) {
						// 	return 0;
						// }
						// if (a.sortSubmissionId < b.sortSubmissionId) {
						// 	return -1;
						// }
						// return 1;
					});
					foo.allFilms.films = sortedFilms;
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}


	getRecentFilms() {
		return new Promise((resolve, reject) => {

			let start = Date.now();

			// init first time through, if can
			if (!this.allFilms.films) {
				// console.log('** first time through getRecentFilms **');
				let tempAllFilms = this.cacheStorage.read(this.cacheStorage.keys.allFilms);
				if (tempAllFilms && tempAllFilms.films) {
					this.allFilms = tempAllFilms;

					this.allFilmsWithArray = {};
					this.allFilmsWithArray.allFilms = {};
					this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
					this.allFilmsWithArray.allFilms.films = [];
					Object.keys(this.allFilms.films).forEach((filmId) => {
						let film = this.allFilms.films[filmId];
						this.allFilmsWithArray.allFilms.films.push(film);
					});
				}
			}
			let modified = 0;
			if (this.allFilms.modified) {
				modified = this.allFilms.modified;
			}

			// console.log('getRecentFilms modified');
			// console.log(modified);



			// let init = Date.now();
			// console.log('    ' + (init - start) + 'msec to init, getRecentFilms');




			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/films/date/' + modified, options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();



					let api = Date.now();
					// console.log('    ' + (api - init) + 'msec to make api call, getRecentFilms');




					// films.allFilms.films


					// console.log('foo');
					// console.log(foo);


					// console.log('foo.allFilms');
					// console.log(foo.allFilms);


					// let tempFilms = foo.allFilms.films;
					// console.log('tempFilms');
					// console.log(tempFilms);
					// this.cacheStorage.write(this.cacheStorage.keys.allFilms, foo.allFilms);

									// tempAllFilms = data.allFilms;
									// localStorage.setItem('all-films', JSON.stringify(tempAllFilms));


					if (this.allFilms.films) {
						// console.log('----  test if should update, count = ' + foo.allFilms.films.length);
						if (foo.allFilms.films.length > 0) {
							// console.log('----  updating, count = ' + foo.allFilms.films.length);
							foo.allFilms.films.forEach((film) => {
								this.trimFilm(film);
								this.allFilms.films[film.filmId] = film;
							});
							this.allFilms.modified = foo.allFilms.modified;


							this.cacheStorage.write(this.cacheStorage.keys.allFilms, this.allFilms);

							this.allFilmsWithArray = {};
							this.allFilmsWithArray.allFilms = {};
							this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
							this.allFilmsWithArray.allFilms.films = [];
							Object.keys(this.allFilms.films).forEach((filmId) => {
								let film = this.allFilms.films[filmId];
								this.allFilmsWithArray.allFilms.films.push(film);
							});
						}
					} else {
						// console.log('----  first time through, count = ' + foo.allFilms.films.length);
						// convert to object form
						let objectAllFilms: any = {};
						objectAllFilms.modified = foo.allFilms.modified;
						objectAllFilms.films = {};
						foo.allFilms.films.forEach((film) => {
							this.trimFilm(film);
							objectAllFilms.films[film.filmId] = film;
						});

						this.allFilms = objectAllFilms;


						this.cacheStorage.write(this.cacheStorage.keys.allFilms, this.allFilms);

						this.allFilmsWithArray = {};
						this.allFilmsWithArray.allFilms = {};
						this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
						this.allFilmsWithArray.allFilms.films = [];
						Object.keys(this.allFilms.films).forEach((filmId) => {
							let film = this.allFilms.films[filmId];
							this.allFilmsWithArray.allFilms.films.push(film);
						});
					}





					// let process = Date.now();
					// console.log('    ' + (process - api) + 'msec to process list, getRecentFilms');





					// console.log('this.allFilms');
					// console.log(this.allFilms);


					// console.log('this.allFilmsWithArray');
					// console.log(this.allFilmsWithArray);


					let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {


						if (a.title.toLowerCase() === b.title.toLowerCase()) {
							return 0;
						}
						if (a.title.toLowerCase() < b.title.toLowerCase()) {
							return -1;
						}
						return 1;

						// if (a.sortSubmissionId === b.sortSubmissionId) {
						// 	return 0;
						// }
						// if (a.sortSubmissionId < b.sortSubmissionId) {
						// 	return -1;
						// }
						// return 1;
					});
					this.allFilmsWithArray.allFilms.films = sortedFilms;




					// let sort = Date.now();
					// console.log('    ' + (sort - process) + 'msec to sort list, getRecentFilms');





					// let end = Date.now();
					// console.log('    ' + (end - start) + 'msec total, getRecentFilms');




					resolve(this.allFilmsWithArray);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}


	private trimFilm(film: any) {
		delete film['aspectRatio'];
		delete film['countriesFilmed'];
		delete film['createdBy'];
		delete film['deleted'];
		delete film['deletedBy'];
		delete film['facebookUrl'];
		delete film['filmColor'];
		delete film['filmFormat'];
		delete film['filmSound'];
		delete film['genres'];
		// delete film['languages'];
		delete film['otherSocialUrl'];
		delete film['submissionDeadline'];
		delete film['submissionDiscountCode'];
		delete film['submissionFee'];
		delete film['submissionProvidedCdnTitle'];
		// delete film['subtitleLanguages'];
		delete film['synopsisEnglish'];
		delete film['synopsisOriginal'];
		delete film['titleEnglish'];
		delete film['titleOriginal'];
		delete film['types'];
		delete film['twitterUrl'];
		delete film['websiteUrl'];

/*
acknowledgementSentDate : 1469817024462
aspectRatio : "1.78:1"
cdnId : "171336032"
cdnPassword : "20thankyou16"
cdnRequiresPassword : true
cdnSource : "vimeo"
cdnUrl : "//player.vimeo.com/video/171336032?title=0&amp;byline=0&amp;portrait=0"
countriesFilmed : "USA"
country : "USA"
created : 1469769347150
createdBy : "c3bed8716ae14d6693b336dfce19d02e"
deleted : null
deletedBy : ""
eventId : "b3b5117aba6249e49084a02d7a1c2c6e"
facebookUrl : "https://www.facebook.com/pastpresentfutureshortfilm/"
filmColor : "Color"
filmDate : 1464739200000
filmFormat : "DVD, Secure Online Screener"
filmId : "d960f66d6ba54a55874d8a321458c9b6"
filmSound : ""
filmmakers : "Jessica Frierson, Jessica Frierson, Alex Perez"
genres : "Drama, African American, Black, Disability Culture, Hispanic, Youth/Teen"
haveDefaultPosterImage : true
isAnimation : false
isBlackAndWhile : false
isDocumentary : false
isFeature : false
isNarrative : true
isShort : true
isStudent : false
isSubtitled : false
languages : "English"
largePosterUrl : "https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/sedonafilmfestival/2017/reviewer/image/171134-large.jpg"
live : true
modified : 1477805302669
modifiedBy : "709db6f5a68b404f8f5b879a5c43305f"
notes : ""
organizationId : "741cf26002ce4f248238f52d3f5c3351"
otherSocialUrl : ""
posterUrl : "https://s3-us-west-2.amazonaws.com/cdn.ptffportal.org/sedonafilmfestival/2017/reviewer/image/171134.jpg"
programNotes : ""
programVote : "reviewing"
runtime : 14
runtimeSeconds : 784
screeningAwards : ""
sortSubmissionId : "171134"
submissionAcceptance : "UNDECIDED"
submissionDate : 6312859286400000
submissionDeadline : ""
submissionDiscountCode : ""
submissionFee : "25.00"
submissionId : "171134"
submissionPassword : ""
submissionProvidedCdnPassword : "20thankyou16"
submissionProvidedCdnTitle : "Past, Present, Future"
submissionProvidedCdnUrl : "https://vimeo.com/171336032/"
submissionRequiresPassword : false
submissionSource : "withoutabox"
submissionStatus : ""
submissionTermsSigned : true
submissionUrl : "https://www.withoutabox.com/01festival/01t_ent/01t_ent_rept.php?festival_id=1318&tracking_id=171134"
submitterEmail : "jessicaschannel@gmail.com"
submitterName : "Jessica Frierson"
submitterPhone : "714-862-9546"
subtitleLanguages : ""
synopsis : "A teenager who's headed in the wrong direction has a life-changing encounter with a Vietnam veteran with PTSD. With the veteran believing he's still in Vietnam, he mistakes the teenager for his own rebellious brother whom he lost in the war."
synopsisEnglish : ""
synopsisOriginal : ""
title : "Past, Present, Future"
titleEnglish : ""
titleOriginal : ""
trailerUrl : ""
twitterUrl : ""
type : "short"
types : "Narrative Fiction, Short, Short Films"
viewMethod : "showCdn"
vote : "accepted"
websiteUrl : ""
year : "2016"
*/
	}


	getAvailableFilms() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			this.http.get(this.config.basePath + '/v0/films/users/' + userId, options)
				.toPromise()
				.then( (res) => {
					let availableFilmIdInfo = res.json();
					// console.log('availableFilmIdInfo');
					// console.log(availableFilmIdInfo);

					let filmIds = availableFilmIdInfo.availableFilmIds.filmIds;

					// console.log('filmIds');
					// console.log(filmIds);
					// let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {


					// 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
					// 		return 0;
					// 	}
					// 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
					// 		return -1;
					// 	}
					// 	return 1;


					// 	// if (a.sortSubmissionId === b.sortSubmissionId) {
					// 	// 	return 0;
					// 	// }
					// 	// if (a.sortSubmissionId < b.sortSubmissionId) {
					// 	// 	return -1;
					// 	// }
					// 	// return 1;
					// });
					// foo.allFilms.films = sortedFilms;
					resolve(filmIds);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}









	getRecentFilmsIndexedDb() {
		return new Promise((resolve, reject) => {

			let start = Date.now();

			// init first time through, if can

			if (!this.allFilms.films) {
				console.log('** first time through getRecentFilmsIndexedDb **');

				this.cacheStorage.readIndexedDb(this.cacheStorage.keys.allFilms)
				.then((tempAllFilms: any) => {

					if (tempAllFilms && tempAllFilms.films) {
						this.allFilms = tempAllFilms;

						this.allFilmsWithArray = {};
						this.allFilmsWithArray.allFilms = {};
						this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
						this.allFilmsWithArray.allFilms.films = [];
						Object.keys(this.allFilms.films).forEach((filmId) => {
							let film = this.allFilms.films[filmId];
							this.allFilmsWithArray.allFilms.films.push(film);
						});
					}

					let modified = 0;
					if (this.allFilms.modified) {
						modified = this.allFilms.modified;
					}

					console.log('getRecentFilms modified');
					console.log(modified);

					let accessToken = localStorage.getItem('auth-jwt');
					let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
					let options = new RequestOptions({ headers: headers });

					this.http.get(this.config.basePath + '/v0/films/date/' + modified, options)
					.toPromise()
					.then( (res) => {
						let foo = res.json();

						// films.allFilms.films

						// console.log('foo');
						// console.log(foo);

						// console.log('foo.allFilms');
						// console.log(foo.allFilms);

						if (this.allFilms.films) {
							console.log('----  test if should update, count = ' + foo.allFilms.films.length);

							if (foo.allFilms.films.length > 0) {
								console.log('----  updating, count = ' + foo.allFilms.films.length);

								foo.allFilms.films.forEach((film) => {
									this.trimFilm(film);
									this.allFilms.films[film.filmId] = film;
								});
								this.allFilms.modified = foo.allFilms.modified;

								this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allFilms, this.allFilms)
								.then(() => {
									this.allFilmsWithArray = {};
									this.allFilmsWithArray.allFilms = {};
									this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
									this.allFilmsWithArray.allFilms.films = [];
									Object.keys(this.allFilms.films).forEach((filmId) => {
										let film = this.allFilms.films[filmId];
										this.allFilmsWithArray.allFilms.films.push(film);
									});

									this.sortTheFilms();
									resolve(this.allFilmsWithArray);
								})
								.catch((err) => {
									// TODO - handle errors?
									this.log.error(err);
									resolve();
								});
							} else {
								this.sortTheFilms();
								resolve(this.allFilmsWithArray);
							}
						} else {
							console.log('----  first time through, count = ' + foo.allFilms.films.length);

							// convert to object form
							let objectAllFilms: any = {};
							objectAllFilms.modified = foo.allFilms.modified;
							objectAllFilms.films = {};
							foo.allFilms.films.forEach((film) => {
								this.trimFilm(film);
								objectAllFilms.films[film.filmId] = film;
							});

							this.allFilms = objectAllFilms;

							this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allFilms, this.allFilms)
							.then(() => {
								this.allFilmsWithArray = {};
								this.allFilmsWithArray.allFilms = {};
								this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
								this.allFilmsWithArray.allFilms.films = [];
								Object.keys(this.allFilms.films).forEach((filmId) => {
									let film = this.allFilms.films[filmId];
									this.allFilmsWithArray.allFilms.films.push(film);
								});

								this.sortTheFilms();
								resolve(this.allFilmsWithArray);
							})
							.catch((err) => {
								// TODO - handle errors?
								this.log.error(err);

								this.allFilmsWithArray = {};
								this.allFilmsWithArray.allFilms = {};
								this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
								this.allFilmsWithArray.allFilms.films = [];
								Object.keys(this.allFilms.films).forEach((filmId) => {
									let film = this.allFilms.films[filmId];
									this.allFilmsWithArray.allFilms.films.push(film);
								});

								this.sortTheFilms();
								resolve(this.allFilmsWithArray);

							});

							// this.allFilmsWithArray = {};
							// this.allFilmsWithArray.allFilms = {};
							// this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
							// this.allFilmsWithArray.allFilms.films = [];
							// Object.keys(this.allFilms.films).forEach((filmId) => {
							// 	let film = this.allFilms.films[filmId];
							// 	this.allFilmsWithArray.allFilms.films.push(film);
							// });
						}
						// console.log('this.allFilms');
						// console.log(this.allFilms);

						// console.log('this.allFilmsWithArray');
						// console.log(this.allFilmsWithArray);


						// let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {
						// 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
						// 		return 0;
						// 	}
						// 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
						// 		return -1;
						// 	}
						// 	return 1;
						// });
						// this.allFilmsWithArray.allFilms.films = sortedFilms;

						// resolve(this.allFilmsWithArray);
					})
					.catch((err) => {			// this is a Response object, with res.status === 401, for example
						// TODO - handle errors?
						this.log.error(err);
						// !!! TODO - check that all promise functions resolve or reject
						resolve();
					});

				})
				.catch((errz) => {
					// TODO - handle errors?
// !!! TODO - should error, but continue
					this.log.error(errz);






					let modified = 0;
					if (this.allFilms.modified) {
						modified = this.allFilms.modified;
					}

					console.log('getRecentFilms modified');
					console.log(modified);

					let accessToken = localStorage.getItem('auth-jwt');
					let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
					let options = new RequestOptions({ headers: headers });

					this.http.get(this.config.basePath + '/v0/films/date/' + modified, options)
					.toPromise()
					.then( (res) => {
						let foo = res.json();

						// films.allFilms.films

						// console.log('foo');
						// console.log(foo);

						// console.log('foo.allFilms');
						// console.log(foo.allFilms);

						// console.log('foo.allFilms.films.length');
						// console.log(foo.allFilms.films.length);

						if (this.allFilms.films) {
							console.log('----  test if should update, count = ' + foo.allFilms.films.length);

							if (foo.allFilms.films.length > 0) {
								console.log('----  updating, count = ' + foo.allFilms.films.length);

								foo.allFilms.films.forEach((film) => {
									this.trimFilm(film);
									this.allFilms.films[film.filmId] = film;
								});
								this.allFilms.modified = foo.allFilms.modified;

								this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allFilms, this.allFilms)
								.then(() => {
									this.allFilmsWithArray = {};
									this.allFilmsWithArray.allFilms = {};
									this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
									this.allFilmsWithArray.allFilms.films = [];
									Object.keys(this.allFilms.films).forEach((filmId) => {
										let film = this.allFilms.films[filmId];
										this.allFilmsWithArray.allFilms.films.push(film);
									});

									this.sortTheFilms();
									resolve(this.allFilmsWithArray);
								})
								.catch((err) => {
									// TODO - handle errors?
									this.log.error(err);
									resolve();
								});
							} else {
								this.sortTheFilms();
								resolve(this.allFilmsWithArray);
							}
						} else {
							console.log('----  first time through, count = ' + foo.allFilms.films.length);

							// convert to object form
							let objectAllFilms: any = {};
							objectAllFilms.modified = foo.allFilms.modified;
							objectAllFilms.films = {};
							foo.allFilms.films.forEach((film) => {
								this.trimFilm(film);
								objectAllFilms.films[film.filmId] = film;
							});

							this.allFilms = objectAllFilms;

							this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allFilms, this.allFilms)
							.then(() => {
								this.allFilmsWithArray = {};
								this.allFilmsWithArray.allFilms = {};
								this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
								this.allFilmsWithArray.allFilms.films = [];
								Object.keys(this.allFilms.films).forEach((filmId) => {
									let film = this.allFilms.films[filmId];
									this.allFilmsWithArray.allFilms.films.push(film);
								});

								this.sortTheFilms();
								resolve(this.allFilmsWithArray);
							})
							.catch((err) => {
								// TODO - handle errors?
								this.log.error(err);

								this.allFilmsWithArray = {};
								this.allFilmsWithArray.allFilms = {};
								this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
								this.allFilmsWithArray.allFilms.films = [];
								Object.keys(this.allFilms.films).forEach((filmId) => {
									let film = this.allFilms.films[filmId];
									this.allFilmsWithArray.allFilms.films.push(film);
								});

								this.sortTheFilms();
								resolve(this.allFilmsWithArray);

							});

							// this.allFilmsWithArray = {};
							// this.allFilmsWithArray.allFilms = {};
							// this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
							// this.allFilmsWithArray.allFilms.films = [];
							// Object.keys(this.allFilms.films).forEach((filmId) => {
							// 	let film = this.allFilms.films[filmId];
							// 	this.allFilmsWithArray.allFilms.films.push(film);
							// });
						}
						// console.log('this.allFilms');
						// console.log(this.allFilms);

						// console.log('this.allFilmsWithArray');
						// console.log(this.allFilmsWithArray);


						// let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {
						// 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
						// 		return 0;
						// 	}
						// 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
						// 		return -1;
						// 	}
						// 	return 1;
						// });
						// this.allFilmsWithArray.allFilms.films = sortedFilms;

						// resolve(this.allFilmsWithArray);
					})
					.catch((err) => {			// this is a Response object, with res.status === 401, for example
						// TODO - handle errors?
						this.log.error(err);
						// !!! TODO - check that all promise functions resolve or reject
						resolve();
					});












				});

			} else {

				console.log('** already been through getRecentFilms **');



				let modified = 0;
				if (this.allFilms.modified) {
					modified = this.allFilms.modified;
				}

				console.log('getRecentFilms modified');
				console.log(modified);

				let accessToken = localStorage.getItem('auth-jwt');
				let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
				let options = new RequestOptions({ headers: headers });

				this.http.get(this.config.basePath + '/v0/films/date/' + modified, options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					// films.allFilms.films

					// console.log('foo');
					// console.log(foo);

					// console.log('foo.allFilms');
					// console.log(foo.allFilms);

					// console.log('foo.allFilms.films.length');
					// console.log(foo.allFilms.films.length);


					if (this.allFilms.films) {
						console.log('----  test if should update, count = ' + foo.allFilms.films.length);

						if (foo.allFilms.films.length > 0) {
							console.log('----  updating, count = ' + foo.allFilms.films.length);

							foo.allFilms.films.forEach((film) => {
								this.trimFilm(film);
								this.allFilms.films[film.filmId] = film;
							});
							this.allFilms.modified = foo.allFilms.modified;

							this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allFilms, this.allFilms)
							.then(() => {
								this.allFilmsWithArray = {};
								this.allFilmsWithArray.allFilms = {};
								this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
								this.allFilmsWithArray.allFilms.films = [];
								Object.keys(this.allFilms.films).forEach((filmId) => {
									let film = this.allFilms.films[filmId];
									this.allFilmsWithArray.allFilms.films.push(film);
								});

								this.sortTheFilms();
								resolve(this.allFilmsWithArray);
							})
							.catch((err) => {
								// TODO - handle errors?
								this.log.error(err);
								resolve();
							});
						} else {
							this.sortTheFilms();
							resolve(this.allFilmsWithArray);
						}
					} else {
						console.log('----  first time through, count = ' + foo.allFilms.films.length);

						// convert to object form
						let objectAllFilms: any = {};
						objectAllFilms.modified = foo.allFilms.modified;
						objectAllFilms.films = {};
						foo.allFilms.films.forEach((film) => {
							this.trimFilm(film);
							objectAllFilms.films[film.filmId] = film;
						});

						this.allFilms = objectAllFilms;

						this.cacheStorage.writeIndexedDb(this.cacheStorage.keys.allFilms, this.allFilms)
						.then(() => {
							this.allFilmsWithArray = {};
							this.allFilmsWithArray.allFilms = {};
							this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
							this.allFilmsWithArray.allFilms.films = [];
							Object.keys(this.allFilms.films).forEach((filmId) => {
								let film = this.allFilms.films[filmId];
								this.allFilmsWithArray.allFilms.films.push(film);
							});

							this.sortTheFilms();
							resolve(this.allFilmsWithArray);
						})
						.catch((err) => {
							// TODO - handle errors?
							this.log.error(err);

							this.allFilmsWithArray = {};
							this.allFilmsWithArray.allFilms = {};
							this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
							this.allFilmsWithArray.allFilms.films = [];
							Object.keys(this.allFilms.films).forEach((filmId) => {
								let film = this.allFilms.films[filmId];
								this.allFilmsWithArray.allFilms.films.push(film);
							});

							this.sortTheFilms();
							resolve(this.allFilmsWithArray);

						});

						// this.allFilmsWithArray = {};
						// this.allFilmsWithArray.allFilms = {};
						// this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
						// this.allFilmsWithArray.allFilms.films = [];
						// Object.keys(this.allFilms.films).forEach((filmId) => {
						// 	let film = this.allFilms.films[filmId];
						// 	this.allFilmsWithArray.allFilms.films.push(film);
						// });
					}
					// console.log('this.allFilms');
					// console.log(this.allFilms);

					// console.log('this.allFilmsWithArray');
					// console.log(this.allFilmsWithArray);


					// let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {
					// 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
					// 		return 0;
					// 	}
					// 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
					// 		return -1;
					// 	}
					// 	return 1;
					// });
					// this.allFilmsWithArray.allFilms.films = sortedFilms;

					// resolve(this.allFilmsWithArray);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					// !!! TODO - check that all promise functions resolve or reject
					resolve();
				});







			}


/*
			if (!this.allFilms.films) {
				// console.log('** first time through getRecentFilms **');
				let tempAllFilms = this.cacheStorage.read(this.cacheStorage.keys.allFilms);
				if (tempAllFilms && tempAllFilms.films) {
					this.allFilms = tempAllFilms;

					this.allFilmsWithArray = {};
					this.allFilmsWithArray.allFilms = {};
					this.allFilmsWithArray.allFilms.modfied = this.allFilms.modified;
					this.allFilmsWithArray.allFilms.films = [];
					Object.keys(this.allFilms.films).forEach((filmId) => {
						let film = this.allFilms.films[filmId];
						this.allFilmsWithArray.allFilms.films.push(film);
					});
				}
			}
*/



		});
	}


	private sortTheFilms() {
		let sortedFilms = this.allFilmsWithArray.allFilms.films.sort((a: any, b: any) => {
			if (a.title.toLowerCase() === b.title.toLowerCase()) {
				return 0;
			}
			if (a.title.toLowerCase() < b.title.toLowerCase()) {
				return -1;
			}
			return 1;
		});
		this.allFilmsWithArray.allFilms.films = sortedFilms;
	}


/*
	getAvailableFilmsIndexedDb() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			this.http.get(this.config.basePath + '/v0/films/users/' + userId, options)
				.toPromise()
				.then( (res) => {
					let availableFilmIdInfo = res.json();
					// console.log('availableFilmIdInfo');
					// console.log(availableFilmIdInfo);

					let filmIds = availableFilmIdInfo.availableFilmIds.filmIds;

					// console.log('filmIds');
					// console.log(filmIds);
					// let sortedFilms = foo.allFilms.films.sort((a: any, b: any) => {


					// 	if (a.title.toLowerCase() === b.title.toLowerCase()) {
					// 		return 0;
					// 	}
					// 	if (a.title.toLowerCase() < b.title.toLowerCase()) {
					// 		return -1;
					// 	}
					// 	return 1;


					// 	// if (a.sortSubmissionId === b.sortSubmissionId) {
					// 	// 	return 0;
					// 	// }
					// 	// if (a.sortSubmissionId < b.sortSubmissionId) {
					// 	// 	return -1;
					// 	// }
					// 	// return 1;
					// });
					// foo.allFilms.films = sortedFilms;
					resolve(filmIds);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
				});
		});
	}
*/





























	setFilmLiveState(filmId: string, state: boolean) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filmId: filmId,
				live: state
			};
			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/films/' + filmId, body, options)
				.toPromise()
				.then( (res) => {
					let foo = res.json();

					console.log(foo);
					// let bar: any = foo;


					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}


	saveAcknowledgementSentDate(filmId: string, acknowledgementCommunicationId: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filmId: filmId,
				acknowledgementSentDate: Date.now(),
				acknowledgementCommunicationId: acknowledgementCommunicationId
			};
			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/films/' + filmId, body, options)
				.toPromise()
				.then( (res) => {
					// let foo = res.json();

					// console.log(foo);
					// let bar: any = foo;
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}



	saveAcceptLetterSentDate(filmId: string) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filmId: filmId,
				acceptanceSentDate: Date.now()
			};
			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/films/' + filmId, body, options)
				.toPromise()
				.then( (res) => {
					// let foo = res.json();

					// console.log(foo);
					// let bar: any = foo;
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}




	saveRejectLetterSentDate(filmId: string, rejectionCommunicationId: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filmId: filmId,
				rejectionSentDate: Date.now(),
				rejectionCommunicationId: rejectionCommunicationId
			};
			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/films/' + filmId, body, options)
				.toPromise()
				.then((res) => {
					// let result = res.json();

					// console.log(foo);
					// let bar: any = foo;
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}






	createFilm(newFilmData: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = newFilmData;
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films', body, options)
				.toPromise()
				.then((res) => {
					let foo = res.json();
					console.log(foo);
					let bar: any = foo;
					resolve(bar);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}


	updateFilm(filmUpdates: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = filmUpdates;
			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/films/' + filmUpdates.filmId, body, options)
				.toPromise()
				.then( (res) => {
					// let foo = res.json();

					// console.log(foo);
					// let bar: any = foo;
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}


	exportProgramFilms(filename, data) {
		// console.log('<------ exportProgramFilms -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films/program', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from exportProgramFilms');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}





	exportReviewerStats(filename, data) {
		// console.log('<------ exportReviewerStats -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films/reviewerstats', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from exportReviewerStats');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}




	exportCampaignUsers(filename, data) {
		// console.log('<------ exportCampaignUsers -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/users/campaign', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from exportProgramFilms');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}


	agileExport(filename, data) {
		// console.log('<------ exportProgramFilms -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films/agile', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from exportProgramFilms');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}





	gridLabelExport(filename, data) {
		// console.log('<------ gridLabelExport -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/labels', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from gridLabelExport');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}





	gridPresenterNotesExport(filename, data) {
		// console.log('<------ gridPresenterNotesExport -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/presenternotes', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from gridLabelExport');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}




	gridBallotExport(filename, data) {
		// console.log('<------ gridBallotExport -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/ballots', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from gridLabelExport');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}







	gridBallotSheetsExport(filename, data) {
		// console.log('<------ gridBallotExport -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/sheets', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from gridLabelExport');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject(err);
				});
		});
	}




	exportFilmContacts(filename, data) {
		// console.log('<------ exportFilmContacts -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films/contacts', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from exportProgramFilms');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}





	exportFilmsWithLinks(filename, data) {
		// console.log('<------ exportFilmsWithLinks -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films/filmswithlinks', body, options)
				.toPromise()
				.then((res) => {
					let result: any = res.json();
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}







	exportFilmNames(filename, data) {
		// console.log('<------ exportFilmNames -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films/filmnames', body, options)
				.toPromise()
				.then((res) => {
					let result: any = res.json();
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}













	exportReelTimely(filename, data) {
		// console.log('<------ exportReelTimely -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/reeltimely', body, options)
				.toPromise()
				.then((res) => {
					let result: any = res.json();
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}





	exportEventive(filename, data) {
		// console.log('<------ exportEventive -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/eventive', body, options)
				.toPromise()
				.then((res) => {
					let result: any = res.json();
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}




	exportCustomProgram(filename, data) {
		// console.log('<------ exportCustomProgram -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/customprogram', body, options)
				.toPromise()
				.then((res) => {
					let result: any = res.json();
					resolve(result);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					console.log(err);
					reject(err);
				});
		});
	}



	exportBallotResults(filename, data) {
		// console.log('<------ exportBallotResults -------->');
		// console.log('filename');
		// console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/grids/ballotresults', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from exportProgramFilms');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}





	exportFile(filename, data) {
		console.log('<------ exportProgramFilms -------->');
		console.log('filename');
		console.log(filename);
		// console.log('data');
		// console.log(data);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {
				filename: filename,
				data: data
			};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/files', body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from exportProgramFilms');
					console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}



	createFilmUrls(submissionId) {
		// console.log('<------ createFilmUrls -------->');
		// console.log('submissionId');
		// console.log(submissionId);

		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = {};
			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/films/urls/' + submissionId, body, options)
				.toPromise()
				.then( (res) => {
					let foo: any = res.json();
					// console.log('returned from createFilmUrls');
					// console.log(foo);
					resolve(foo);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});
	}


/*
	importFilmFreeway(newFilmData: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let payload = newFilmData;
			let body = JSON.stringify(payload);





			this.http.post(this.config.basePath + '/v0/films', body, options)
				.toPromise()
				.then((res) => {
					let foo = res.json();
					console.log(foo);
					let bar: any = foo;
					resolve(bar);
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					// TODO - handle errors?
					this.log.error(err);
					reject();
				});
		});



			var target = document.getElementById('filmFreewayFilnameId');
			var uploadUrl = apiHost + '/v0/films/filmfreeway';
			var formData = new FormData();
			formData.append('filmsfile', target.files[0]);

			$http.post(uploadUrl, formData, {
				transformRequest: angular.identity,
				headers: {'Content-Type': undefined}
			})
			.success(function(data, status, headers, config) {
//				console.log('got here #u1');
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				ToastService.showMessage('FilmFreeway films uploaded successfully!');
			})
			.error(function(data, status, headers, config) {
//				console.log('got here #u2');

				Log.warn('Could not upload to FilmFreeway.');
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				ToastService.showMessage('The server is not available, please try again later.');
			});




	}
*/




	importWithoutabox() {

	}


}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/reviewer-film.service.ts